import { apiSpecialtyOptions } from "apis";
import { UseAppFormProps } from "hooks/useAppForm";
import useAppSelector from "hooks/useAppSelector";
import React, { useEffect } from "react";
import { FormValueProps } from ".";
import AppImage from "components/AppImage";

interface Props {
    form: UseAppFormProps<FormValueProps>
}

export const PageSelectUnit: React.FC<Props> = ({ form }) => {
    const specialty = useAppSelector(state => state.specialty);
    useEffect(() => {
        apiSpecialtyOptions({});
    }, [])
    return (
        <div className="p-4 bg-white rounded shadow">
            <h2 className="text-lg font-bold mb-4">CHỌN CHUYÊN KHOA</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                {specialty.list.options.map((s, i) => (
                    <div
                        key={i}
                        onClick={() => form.handleChange({ specialtyId: s.id })}
                        className="border p-3 rounded cursor-pointer hover:border-blue-500 flex items-center gap-3"
                    >
                        <AppImage
                            src={s.thumbnailUrl}
                            alt="logo"
                            className="w-12 h-12 object-cover rounded-full border"
                        />
                        <div>
                            <p className="font-semibold">{s.name}</p>
                            <p className="text-gray-500">{s.description}</p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};
